import React from "react";
import AuthForm from "./Form";

const Register = () => {
  return <AuthForm type="register" />;
};

export default Register;
